export function fmtFCFA(n) {
  const num = Number(n || 0);
  return new Intl.NumberFormat("fr-FR").format(Math.round(num)) + " FCFA";
}

export function fmtDate(d) {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return d;
  }
}

export function fmtDateTime(d) {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return d;
  }
}

export const ROLES = {
  CEO: "CEO",
  ACEO: "Assistant CEO",
  GM: "General Manager",
  FM: "Financial Manager",
  EMPLOYEE: "Employee",
  INTERN: "Intern",
  SS: "Site Supervisor",
  VISITOR: "Visitor",
};

export function statusBadgeClass(status) {
  const s = (status || "").toLowerCase();
  const green = "bg-emerald-100 text-emerald-800 border-emerald-200";
  const blue = "bg-blue-100 text-blue-800 border-blue-200";
  const amber = "bg-amber-100 text-amber-800 border-amber-200";
  const red = "bg-red-100 text-red-800 border-red-200";
  const neutral = "bg-slate-100 text-slate-700 border-slate-200";
  if (["active", "in process", "in progress", "issued", "sent", "open"].includes(s)) return blue;
  if (["completed", "approved", "executed", "recorded", "paid", "accepted", "done", "resolved", "reconciled"].includes(s)) return green;
  if (["pending", "on hold", "awaiting", "draft", "in review", "submitted", "processing"].includes(s)) return amber;
  if (["cancelled", "canceled", "rejected", "suspended", "declined", "overdue", "failed", "expired"].includes(s)) return red;
  return neutral;
}
